import { CascaderOption } from 'types/base';
import { getCategoryValueByCategoryId } from './product-list/form-items/authentication-config';

// 二级分类中 Twilly（丝巾）对应的 value
export const TWILLY_CATEGORY_VALUE = 'twillys';
export const TWILLY_MAX_QUANTITY = 50;

const toFiniteNumber = (value: unknown) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : undefined;
  }

  if (typeof value === 'string' && value.trim() !== '') {
    const parsedValue = Number(value);
    return Number.isFinite(parsedValue) ? parsedValue : undefined;
  }

  return undefined;
};

// 判断所选分类是否为 Twilly（二级分类 value === 'twillys'）
export const isTwillyProductCategory = (
  categoryIdList: number[] | undefined,
  productCategoryCascaderOptions: CascaderOption[],
) =>
  getCategoryValueByCategoryId(
    categoryIdList?.[1],
    productCategoryCascaderOptions,
  ) === TWILLY_CATEGORY_VALUE;

const normalizeQuantity = (quantity?: number) => {
  const parsedQuantity = toFiniteNumber(quantity);

  if (
    parsedQuantity === undefined ||
    !Number.isInteger(parsedQuantity) ||
    parsedQuantity < 1
  ) {
    return 1;
  }

  return Math.min(parsedQuantity, TWILLY_MAX_QUANTITY);
};

export const expandProductListForSubmit = <
  T extends {
    productCategoryIdList?: number[];
    quantity?: number;
  },
>(
  productList: T[],
  productCategoryCascaderOptions: CascaderOption[],
) => {
  return productList.flatMap((product) => {
    if (
      !isTwillyProductCategory(
        product.productCategoryIdList,
        productCategoryCascaderOptions,
      )
    ) {
      return [product];
    }

    return Array.from({ length: normalizeQuantity(product.quantity) }, () => ({
      ...product,
    }));
  });
};

export const getExpandedProductSummary = <
  T extends {
    productCategoryIdList?: number[];
    quantity?: number;
    finalSalePrice?: number | null;
    finalRecyclePrice?: number | null;
  },
>(
  productList: T[],
  productCategoryCascaderOptions: CascaderOption[],
  type: number,
) => {
  const expandedProductList = expandProductListForSubmit(
    productList,
    productCategoryCascaderOptions,
  );
  const normalizedType = toFiniteNumber(type);

  const totalCostPrice = expandedProductList.reduce((acc, product) => {
    if (normalizedType === 1) {
      return acc + (toFiniteNumber(product.finalSalePrice) || 0);
    }

    return acc + (toFiniteNumber(product.finalRecyclePrice) || 0);
  }, 0);

  return {
    productCount: expandedProductList.length,
    totalCostPrice,
  };
};
